import React, { useEffect } from 'react';
import './SideDrawer.css';
import { IoIosArrowForward } from "react-icons/io";
import { MdOutlineSupportAgent } from "react-icons/md";
import { MdBusinessCenter } from "react-icons/md";
import { MdDataUsage } from "react-icons/md";

const SideDrawer = ({ isOpen, onClose, width = 400, collapsedWidth = 60, children, onModeChange, drawerMode }) => {
  useEffect(() => {
    if (isOpen && window.innerWidth < 900) {
      document.body.classList.add('offcanvas-open');
    } else {
      document.body.classList.remove('offcanvas-open');
    }
    return () => document.body.classList.remove('offcanvas-open');
  }, [isOpen]);

  return (
    <>
      {isOpen && <div className="drawer-backdrop" onClick={onClose} />}
      <div className="drawer-wrapper">
        {isOpen && (
          <button className="drawer-close" onClick={onClose}>
            <IoIosArrowForward size={'2rem'} />
          </button>
        )}
        {!isOpen && (
          <button className='drawer-mini-trigger' onClick={onClose} aria-label='Open panel'>
            <MdDataUsage className='sidebar-icon'/>
          </button>
        )}
        <div className={`side-drawer ${isOpen ? 'open' : 'closed'}`} style={{ width: isOpen ? width : collapsedWidth }}>
          <div className="drawer-buttons">
            <button className={drawerMode === 'topAgents' ? 'active' : ''} onClick={() => onModeChange('topAgents')}><MdOutlineSupportAgent /></button>
            <button className={drawerMode === 'topCustomers' ? 'active' : ''} onClick={() => onModeChange('topCustomers')}><MdBusinessCenter /></button>
          </div>
          {isOpen && <div className="drawer-content">{children}</div>}
        </div>
      </div>
    </>
  );
};

export default SideDrawer;
